import { combineReducers } from "redux";
import InputDataReducers from "./InputData";

export const rootReducers = combineReducers({
  InputDataReducers,
});
